if($('.id--9').length){
    const ConditionalPackingFee = (function() {
        const config = {
            packingUrls: [],
            packingUrlsByCategory: {},
            packingParameterName: "",
            jsonUrl: "/user/documents/zalohy.json?v=" + new Date().getMinutes(),
        };
      
        function loadJson() {
          if (!config.jsonUrl) {
              return Promise.resolve({ products: [], surcharges: [] });
          }
      
          return $.get(config.jsonUrl).then(body => {
              try {
                  const json = body;
      
                  const surchargesByPriceId = {};
                  for (let product of json.products) {
                      surchargesByPriceId[product.surcharge.priceId] = product.surcharge;
                  }
      
                  return { products: json.products, surcharges: Object.values(surchargesByPriceId) };
              } catch (e) {
                  console.error("Failed to parse JSON:", e);
                  return { products: [], surcharges: [] };
              }
          }).fail(error => {
              console.error("Failed to load JSON:", error);
              return { products: [], surcharges: [] };
          });
      }
      
      
        function extractProductDataFromCartWidgetRow($row) {
        
            const identifier = $row.data("microIdentifier"),
                sku = String($row.data("microSku")),
                priceId = parseFloat($row.find("input[name=priceId]").val()),
                url = $row.find(".cart-widget-product-name a").attr("href");
      
            return { priceId, identifier, sku, url };
        }
      
        function extractProductDataFromCartTableRow($row) {
       
            const identifier = $row.data("microIdentifier"),
                sku = String($row.data("microSku")),
                priceId = parseFloat($row.find("input[name=priceId]").val()),
                url = $row.find(".main-link").attr("href");
      
            return { priceId, identifier, sku, url };
        }
      
        function ajaxSubmitFormCartAsync($form) {
            return new Promise(function(resolve, reject) {
                $.ajax({
                    type: $form.attr("method"),
                    url: $form.attr("action"),
                    data: $form.serialize(),
                    success: function(response) {
                        resolve(response);
                    },
                    error: function(error) {
                        reject(error);
                    }
                });
            });
        }
      
        function removePackingItemsFromCart($cart) {
            if (!$cart) {
                return loadDocument("/kosik/").then(function($doc) {
                    return removePackingItemsFromCart($doc.find("#cart-wrapper"));
                });
            }
      
            if (!json) {
                return jsonPromise.then(() => removePackingItemsFromCart($cart));
            }
      
            const promises = $cart.find(".cart-table tr[data-micro=cartItem]").map(function() {
                const $t = $(this);
                const info = extractProductDataFromCartTableRow($t);
                if (isPackingProduct(info)) {
                    return ajaxSubmitFormCartAsync($t.find(".remove-item").closest("form"));
                }
            }).toArray();
      
            return Promise.all(promises);
        }
      
        function addItemToCart(priceId, amount) {
          shoptet.cartShared.addToCart({productCode: priceId, amount: amount});
           /* let $form = $("<form>", { action: shoptet.config.addToCartUrl, method: "POST" });
            $form.append($("<input>", { type: "hidden", name: "priceId", value: priceId }));
            $form.append($("<input>", { type: "hidden", name: "amount", value: amount }));*/
            return ajaxSubmitFormCartAsync($form);
        }
      
        function fetchPackingInfoForProduct(productInfo) {
            return jsonPromise.then(() => {
                const packingProduct = json.products.find(product => product.sku === productInfo.sku);
                return packingProduct ? packingProduct.surcharge : null;
            });
        }
      
        function syncPackingItemsInCart($cart) {
            if (!$cart) {
                return loadDocument("/kosik/").then(function($doc) {
                    return syncPackingItemsInCart($doc.find("#cart-wrapper"));
                });
            }
      
            if (!json) {
                return jsonPromise.then(() => syncPackingItemsInCart($cart));
            }
      
            var packingItemsInCart = {}, promises = [];
            $cart.find(".cart-table tr[data-micro=cartItem]").each(function() {
                const $t = $(this);
                const info = extractProductDataFromCartTableRow($t);
                const amount = parseFloat($t.find("input[name=amount]").val());
      
                if (isPackingProduct(info)) {
                    packingItemsInCart[info.sku] = {
                        $item: $t,
                        sku: info.sku,
                        amount: amount
                    };
                    return;
                }
      
                promises.push(fetchPackingInfoForProduct(info).then(function(packing) {
                    return {
                        $item: $t,
                        amount: amount,
                        packing: packing
                    };
                }));
            });
      
            let didChange = false;
            let wantedPackingItems = {};
            return Promise.all(promises).then(function(items) {
                for (let item of items) {
                    if (!item || !item.packing) continue;
                    if (wantedPackingItems[item.packing.sku]) {
                        wantedPackingItems[item.packing.sku].amount += item.amount;
                    } else {
                        wantedPackingItems[item.packing.sku] = item;
                    }
                }
                console.log(wantedPackingItems);
            }).then(function() {
                let promises = [];
                for (let item of Object.values(packingItemsInCart)) {
                    let wantedItem = wantedPackingItems[item.sku];
                    if (!wantedItem) {
                        promises.push(ajaxSubmitFormCartAsync(item.$item.find(".remove-item").closest("form")));
                    }
                }
                if (promises.length) didChange = true;
                console.log("removed", promises.length);
                return Promise.all(promises);
            }).then(function() {
                let promises = [];
                for (let item of Object.values(wantedPackingItems)) {
                    let inCart = packingItemsInCart[item.packing.sku];
                    if (!inCart) {
                        console.log(item);
                        promises.push(addItemToCart(item.packing.priceId, item.amount));
                    } else if (inCart.amount !== item.amount) {
                        var $quantityForm = inCart.$item.find(".quantity-form");
                        $quantityForm.find("input[name=amount]").val(item.amount);
                        promises.push(ajaxSubmitFormCartAsync($quantityForm));
                    }
                }
                if (promises.length) didChange = true;
                console.log("updated", promises.length);
                return Promise.all(promises);
            }).then(function() {
                return didChange;
            });
        }
      
        function isPackingProduct(productInfo) {
            if (config.packingUrls.includes(productInfo.url)) return true;
            return !!json.surcharges.find(surcharge => surcharge.sku === productInfo.sku);
        }
      
        function currentShippingMethodNeedsPacking() {
            return true;
        }
      
        function lockCartRow($row) {
            var $quantity = $($row).find(".quantity");
      
            $quantity.addClass("readonly");
            $quantity.find(".increase, .decrease").addClass("hidden");
            $quantity.find("input").prop("readonly", true);
            $quantity.attr("title", "Množství nelze měnit, protože je navázané na ostatní položky.");
      
            $($row).find(".remove-item").hide();
        }
      
        let canSubmitOrder = false;
        function handleOrderSubmit(e) {
            console.log("handleOrderSubmit", canSubmitOrder);
            if (canSubmitOrder) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            (!currentShippingMethodNeedsPacking() ? removePackingItemsFromCart() : syncPackingItemsInCart()).then(function() {
                canSubmitOrder = true;
                $("#order-form").submit();
            });
        }
      
        let jsonPromise, json;
        var init = function() {
            jsonPromise = loadJson().then(_json => (json = _json));
      
            $("body.in-krok-2 #order-form").on("submit", function(e) {
                if (e.isDefaultPrevented()) return;
                handleOrderSubmit(e);
            });
      
            if ($("body.in-kosik").length) {
                syncPackingItemsInCart($("#cart-wrapper"));
                document.addEventListener("ShoptetDOMCartContentLoaded", function() {
                    syncPackingItemsInCart($("#cart-wrapper"));
                });
            }
      
            if ($("body.in-krok-1,body.in-krok-2").length) {
                syncPackingItemsInCart().then(function(didChange) {
                    if (didChange) location.reload();
                });
            }
      
            jsonPromise.then(() => {
                console.log(json);
                $(".cart-table tr[data-micro=cartItem]").each(function() {
                    const $t = $(this);
                    const info = extractProductDataFromCartTableRow($t);
                    if (isPackingProduct(info)) lockCartRow($t);
                });
      
                $(".cart-widget .cart-widget-product").each(function() {
                    const $t = $(this);
                    const info = extractProductDataFromCartWidgetRow($t);
                    if (isPackingProduct(info)) lockCartRow($t);
                });
            });
        };
      
        $(document).ready(init);
        document.addEventListener("ShoptetDOMContentLoaded", function() {
          let jsonPromise, json;
          jsonPromise = loadJson().then(_json => (json = _json));
      
            $("body.in-krok-2 #order-form").on("submit", function(e) {
                if (e.isDefaultPrevented()) return;
                handleOrderSubmit(e);
            });
      
            if ($("body.in-kosik").length) {
                syncPackingItemsInCart($("#cart-wrapper"));
                document.addEventListener("ShoptetDOMCartContentLoaded", function() {
                    syncPackingItemsInCart($("#cart-wrapper"));
                });
            }
      
            if ($("body.in-krok-1,body.in-krok-2").length) {
                syncPackingItemsInCart().then(function(didChange) {
                    if (didChange) location.reload();
                });
            }
      
            jsonPromise.then(() => {
                console.log(json);
                $(".cart-table tr[data-micro=cartItem]").each(function() {
                    const $t = $(this);
                    const info = extractProductDataFromCartTableRow($t);
                    if (isPackingProduct(info)) lockCartRow($t);
                });
      
                $(".cart-widget .cart-widget-product").each(function() {
                    const $t = $(this);
                    const info = extractProductDataFromCartWidgetRow($t);
                    if (isPackingProduct(info)) lockCartRow($t);
                });
            });
      
      });
        return { init, config };
      })();
}

